<template>
  <div
    v-if="show"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50"
    @click="$emit('close')"
  >
    <div
      class="relative top-20 mx-auto p-5 border sm:max-w-2xl shadow-lg rounded-md bg-white"
      @click.stop
    >
      <div class="mt-3">
        <h3 class="text-lg font-medium text-gray-900 mb-4">
          {{ mode === 'create' ? 'Создать счет' : 'Редактировать счет' }}
        </h3>
        <form @submit.prevent="submitForm" @click.stop class="space-y-3">
          <div class="grid grid-cols-2 gap-3">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-0.5">
                Договор
              </label>
              <select
                v-model="form.contract_id"
                required
                :disabled="disableContractField"
                :class="{
                  'mt-1 block w-full px-2 py-1.5 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500': true,
                  'bg-gray-100 cursor-not-allowed': disableContractField
                }"
              >
                <option value="">
                  Выберите договор ({{ contracts.length }} доступно)
                </option>
                <option
                  v-for="contract in contracts"
                  :key="contract.id"
                  :value="contract.id"
                >
                  {{ contract.legal_name }}
                </option>
              </select>
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 mb-0.5">
                Дата счета
              </label>
              <input
                type="date"
                v-model="form.date_of_invoice"
                required
                class="mt-1 block w-full px-2 py-1.5 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              />
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 mb-0.5">
                Период платежа
              </label>
              <input
                type="month"
                v-model="form.payment_period"
                required
                class="mt-1 block w-full px-2 py-1.5 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              />
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 mb-0.5">
                Номер счета
              </label>
              <input
                type="text"
                v-model="form.number_of_invoice"
                required
                class="mt-1 block w-full px-2 py-1.5 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              />
            </div>

            <div class="col-span-2">
              <label class="block text-sm font-medium text-gray-700 mb-0.5">
                Комментарий
              </label>
              <textarea
                v-model="form.comment"
                rows="2"
                class="mt-1 block w-full px-2 py-1.5 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              ></textarea>
            </div>

            <div class="col-span-2">
              <div class="space-y-2">
                <label class="flex items-center">
                  <input
                    type="checkbox"
                    v-model="form.draft"
                    class="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <span class="text-sm font-medium text-gray-700"
                    >Черновик</span
                  >
                </label>

                <label class="flex items-center">
                  <input
                    type="checkbox"
                    v-model="form.delivered"
                    class="mr-2 h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                  />
                  <span class="text-sm font-medium text-gray-700"
                    >Поступило на счет</span
                  >
                </label>

                <label class="flex items-center">
                  <input
                    type="checkbox"
                    v-model="form.paid"
                    class="mr-2 h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                  />
                  <span class="text-sm font-medium text-gray-700"
                    >Оплачено</span
                  >
                </label>

                <label class="flex items-center">
                  <input
                    type="checkbox"
                    v-model="form.full_payment"
                    class="mr-2 h-4 w-4 text-amber-600 focus:ring-amber-500 border-gray-300 rounded"
                  />
                  <span class="text-sm font-medium text-gray-700"
                    >Оплата за период</span
                  >
                </label>

                <label class="flex items-center">
                  <input
                    type="checkbox"
                    v-model="form.fake"
                    class="mr-2 h-4 w-4 text-orange-600 focus:ring-orange-500 border-gray-300 rounded"
                  />
                  <span class="text-sm font-medium text-gray-700"
                    >Фейковый счет</span
                  >
                </label>
              </div>
            </div>
          </div>

          <div class="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              @click="$emit('close')"
              class="inline-flex justify-center px-3 py-1.5 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
            >
              Отмена
            </button>
            <button
              type="submit"
              :disabled="loading"
              class="inline-flex justify-center px-3 py-1.5 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
            >
              <span v-if="loading">Сохранение...</span>
              <span v-else>{{
                mode === 'create' ? 'Создать счет' : 'Сохранить'
              }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, watch, onMounted } from 'vue'
  import { billingApi } from '../services/api'

  const props = defineProps({
    show: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'create',
      validator: value => ['create', 'edit'].includes(value)
    },
    invoice: {
      type: Object,
      default: () => ({})
    },
    currentContractId: {
      type: [String, Number],
      default: ''
    },
    disableContractField: {
      type: Boolean,
      default: false
    }
  })

  const emit = defineEmits(['close', 'submit'])

  const loading = ref(false)
  const contracts = ref([])

  const form = ref({
    contract_id: '',
    date_of_invoice: '',
    payment_period: '',
    number_of_invoice: '',
    comment: '',
    draft: false,
    delivered: false,
    paid: false,
    full_payment: false,
    fake: false
  })

  const loadContracts = async () => {
    try {
      if (props.disableContractField && props.currentContractId) {
        const response = await billingApi.get(
          `/contract/${props.currentContractId}`)
        contracts.value = [response.data]
      } else {
        const response = await billingApi.get('/contract', {
          params: { limit: 999999, active: true }
        })
        contracts.value = response.data.contracts || response.data
      }
    } catch (err) {
      console.error('Error loading contracts:', err)
    }
  }

  const resetForm = () => {
    form.value = {
      contract_id: props.disableContractField ? props.currentContractId : '',
      date_of_invoice: '',
      payment_period: '',
      number_of_invoice: '',
      comment: '',
      draft: false,
      delivered: false,
      paid: false,
      full_payment: false,
      fake: false
    }
  }

  const closeModal = () => {
    emit('close')
    resetForm()
  }

  const submitForm = async () => {
    loading.value = true
    try {
      const formData = {
        contract_id: parseInt(form.value.contract_id),
        date_of_invoice: form.value.date_of_invoice,
        payment_period: form.value.payment_period + '-01',
        number_of_invoice: form.value.number_of_invoice,
        comment: form.value.comment,
        draft: form.value.draft,
        delivered: form.value.delivered,
        paid: form.value.paid,
        full_payment: form.value.full_payment,
        fake: form.value.fake
      }

      emit('submit', formData)
    } catch (err) {
      console.error('Error in form submission:', err)
    } finally {
      loading.value = false
    }
  }

  watch(
    () => props.invoice,
    newInvoice => {
      if (newInvoice && Object.keys(newInvoice).length > 0) {
        form.value = {
          id: newInvoice.id,
          contract_id: newInvoice.contract_id,
          date_of_invoice: newInvoice.date_of_invoice,
          payment_period: newInvoice.payment_period
            ? newInvoice.payment_period.substring(0, 7)
            : '',
          number_of_invoice: newInvoice.number_of_invoice,
          comment: newInvoice.comment || '',
          draft: newInvoice.draft || false,
          delivered: newInvoice.delivered || false,
          paid: newInvoice.paid || false,
          full_payment: newInvoice.full_payment || false,
          fake: newInvoice.fake || false
        }
      }
    },
    { immediate: true }
  )

  watch(
    () => props.currentContractId,
    newContractId => {
      if (
        newContractId &&
        props.disableContractField &&
        !form.value.contract_id
      ) {
        form.value.contract_id = newContractId
      }
      if (props.disableContractField && newContractId) {
        loadContracts()
      }
    },
    { immediate: true }
  )

  onMounted(() => {
    loadContracts()
    resetForm()
  })

  watch(
    () => props.show,
    newShow => {
      if (newShow && !props.disableContractField) {
        loadContracts()
      }
    }
  )
</script>
